import { FC } from "react";
import { useTranslation } from "react-i18next";
import Button from  "Components/UI/Button";
import { ButtonsWrapper } from "./styles";

interface IButtonsAction {
  loading?: boolean;
  onConfirm?: () => void;
  onCancel: () => void;
  disabledConfirm?: boolean;
  disabledCancel?: boolean;
  marginTop?: number;
  isSubmit?: boolean;
}

const ButtonsAction: FC<IButtonsAction> = ({
  loading,
  onConfirm,
  onCancel,
  disabledConfirm,
  disabledCancel,
  marginTop,
  isSubmit,
}) => {
  const { t } = useTranslation('personalization');

  return (
    <ButtonsWrapper marginTop={marginTop}>
      {isSubmit && (
        <Button
          className="btnConfirm"
          type="primary"
          htmlType="submit"
          loading={loading}
          disabled={disabledConfirm}
        >
          {loading ? t('buttonsAction.saving') : t('buttonsAction.save')}
        </Button>
      )}
      {!isSubmit && onConfirm && (
        <Button
          className="btnConfirm"
          type="primary"
          loading={loading}
          disabled={disabledConfirm}
          onClick={onConfirm}
        >
          {loading ? t('buttonsAction.saving') : t('buttonsAction.save')}
        </Button>
      )}
      <Button
        className="btnCancel"
        type="text"
        disabled={disabledCancel}
        onClick={onCancel}
      >
        {t('buttonsAction.cancel')}
      </Button>
    </ButtonsWrapper>
  );
};

export default ButtonsAction;
